﻿import axios from 'config/axios';

export default class GroupService {
  static async get() {
    const { data } = await axios.get('groups/');
    return data.results;
  }
}
